import withState from "./withState"
export const wrapRootElement = withState
